import { RolesList, PermissionsList } from '@/helpers/permissions';

const getters = {
  isAuthenticated: state => !!state.accessToken,
  isTokenExpired: state => Date.now() >= state.expiryTokenDate,
  rolesStatus: state => Object.keys(RolesList).reduce((result, roleName) => {
    result[`is${roleName}`] = !!state.roles[RolesList[roleName]];
    return result;
  }, {}),
  permissionsStatus: state => Object.keys(PermissionsList).reduce((result, permissionName) => {
    result[`is${permissionName}Allowed`] = state.permissions[PermissionsList[permissionName]];
    return result;
  }, {}),
  waitingForApprovalList: (state) => state.control_points.filter(item => item.execution_status === 'waiting_for_approval'),
  inProgressList: (state) => state.control_points.filter(item => item.execution_status === 'in_progress'),
  completedList: (state) => state.control_points.filter(item => item.execution_status === 'completed'),
};

export default getters;
